import "jquery-zoom";
import OwlCarousel from "react-owl-carousel";
import PropTypes from "prop-types";
import React from "react";

export default class Carousels extends React.PureComponent {

  static propTypes = {
    "designerName": PropTypes.string.isRequired,
    "images": PropTypes.array.isRequired,
    "name": PropTypes.array.isRequired
  };

  constructor (props) {
    super(props);

    this.carousel = React.createRef();
    this.isMobileScreen = document.body.clientWidth < 767;
  }

  componentDidMount () {
    this.configure();
  }

  componentDidUpdate (prevProps) {
    const {images} = this.props;
    if (prevProps.images !== images) {
      this.configure();
    }
  }

  configure = () => {
    if (this.carousel.current) {
      this.carousel.current.to(0, 0);
      $(".zoomBox").zoom();
    }
  };

  handleSideImageClick = (event) => {
    if (this.carousel.current) {
      this.carousel.current.to($(event.target).data("item"), 500);
    }
  };

  render () {
    let itemNum = 0;
    const {designerName, images, name} = this.props;

    return (
      <div id="Carousels">
        {!this.isMobileScreen &&
        <div className="sideImages">
          {images.map(image => (
            <img
              alt={`${designerName} ${name}`}
              data-item={itemNum++} // eslint-disable-line
              key={`sideImage${image}`}
              onClick={this.handleSideImageClick}
              src={image}
            />))}
        </div>}
        <OwlCarousel
          className="carousel owl-theme"
          dots={this.isMobileScreen}
          items={1}
          loadedClass="inline-block"
          ref={this.carousel}
        >
          {images.map(image =>
            <div
              className="zoomBox"
              key={`${name}${image}`}
            >
              <img
                alt={`${designerName} ${name}`}
                src={image}
              />
            </div>)}
        </OwlCarousel>
      </div>
    );
  }
}
